import React, { FC, useMemo } from 'react';

import { DateRange } from 'react-day-picker';

import { Calendar } from '../ui';

import { DatePickerMode, DatePickerValue } from "./DatePicker.types";

export type DatePickerCalendarProps = Omit<React.ComponentProps<typeof Calendar>, 'selected' | 'onSelect'> & {
  value?: DatePickerValue;
  onChange: (value: DatePickerValue | undefined, selectedDay: Date) => void;
};

const DatePickerCalendar: FC<DatePickerCalendarProps> = ({
  mode,
  value,
  numberOfMonths,
  disabled,
  onChange,
  ...rest
}) => {
  const commonProps = useMemo(() => {
    return {
      className: 'border border-base-border rounded-md p-3',
      disabled,
      ...rest,
      numberOfMonths,
      initialFocus: true,
      classNames: {
        head_cell:
          'text-muted-foreground rounded-md w-9 font-normal text-[0.8rem]',
        nav_button:
          'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 shadow-none border border-base-input rounded-md flex items-center justify-center',
        day: 'h-9 w-9 p-0 font-normal aria-selected:opacity-100 rounded-md hover:bg-base-accent',
        day_selected:
          'bg-indigo-600 text-white hover:bg-indigo-600 hover:text-white focus:bg-indigo-600 focus:text-white',
        day_today: 'text-base-foreground bg-base-accent',
        day_outside:
          'day-outside text-base-mutedForeground aria-selected:bg-accent aria-selected:text-base-primaryForeground',
        month: 'space-y-4 text-base-foreground',
        head_row: 'flex text-base-mutedForeground'
      }
    }
  }, [disabled, rest, numberOfMonths]);

  if (mode === DatePickerMode.SINGLE) {
    return (
      <Calendar
        {...commonProps}
        mode={DatePickerMode.SINGLE}
        selected={value ? new Date(value as Date | string) : undefined}
        onSelect={onChange}
      />
    );
  }

  return (
    <Calendar
      {...commonProps}
      mode={DatePickerMode.RANGE}
      selected={value as DateRange}
      onSelect={onChange}
      classNames={{
        ...commonProps.classNames,
      }}
    />
  );
};

export default DatePickerCalendar;
